import { Component, OnInit } from '@angular/core';
import { NavigationItem } from '../../../shared/navigation/navigation_item';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { INTEGRATE_SETUP_PATH } from '../../../shared/navigation/constants';
import { navSetActiveStep } from '../../../shared/navigation/state/navigation_actions_creator';
import { IAppState } from '../../../../app_state';

@Component({
  selector: 'yi-wizard',
  template: require('./wizard.component.html'),
  styles: [require('./wizard.component.scss')]
})
export class WizardComponent implements OnInit {

  items: Array<NavigationItem>;
  activeStep: NavigationItem;
  isLastStep = false;
  lastStepName = '';

  constructor(
    private store: Store<IAppState>,
    private translateService: TranslateService
  ) {
    this.store.select(state => state.app.install.navigation).subscribe(
      items => {
        this.items = items.navigationItems;
        this.activeStep = {...this.items.filter(item => item.active === true)[0]};
        this.isLastStep = this.activeStep.isLastStep;
        this.lastStepName = (this.translateService.instant(this.activeStep.name) + '-last-step').toLowerCase();
      });
  }

  ngOnInit() {

  }

  setNewSelectedStep(event) {
      this.store.dispatch(navSetActiveStep({activeStep: event.item}));
    }

  shouldShowFooter() {
    return this.activeStep.url !== INTEGRATE_SETUP_PATH;
  }
}
